import React, { Component } from 'react'
import MediaStates from '@slite/editor/lib/components/MediaStates'

class FileUploading extends Component {
  componentDidUpdate(prevProps) {
    // Not uploading
    if (!prevProps.fileUpload || !this.props.fileUpload) {
      return false
    }

    // File upload ended
    if (!prevProps.fileUpload.get('url') && this.props.fileUpload.get('url')) {
      const fileData = this.props.fileUpload.toJS()
      const uuid = this.props.fileUpload.uuid
      this.props.resetFileUpload({ uuid })
      this.props.editor.command(
        'insertUploadedFile',
        this.props.node.key,
        fileData
      )
    }
  }

  render() {
    if (!this.props.fileUpload) {
      return null
    }
    const error = this.props.fileUpload.error
    return (
      <MediaStates
        loading={true}
        error={error}
        mediaType={'file'}
        wrapperStyle={{
          height: error ? 124 : 94,
        }}
      />
    )
  }
}

export default FileUploading
